export enum VisibilityProfileType {
  TRADER,
  SALES,
}

export namespace VisibilityProfileType {
  let elements = [VisibilityProfileType.TRADER, VisibilityProfileType.SALES];
  let alias = "com.bcdfx.model.VisibilityProfileType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
